var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1111 22H8.66666V8.66667H13.1111V10.8889C14.0584 9.68361 15.4951 8.96508 17.0278 8.93C19.784 8.9453 22.008 11.1882 22 13.9444V22H17.5555V14.5C17.3778 13.2584 16.3131 12.3373 15.0589 12.34C14.5103 12.3573 13.9924 12.5976 13.6249 13.0051C13.2573 13.4128 13.0718 13.9526 13.1111 14.5V22ZM6.44444 22H2V8.66667H6.44444V22ZM4.22222 6.44444C2.99492 6.44444 2 5.44952 2 4.22222C2 2.99492 2.99492 2 4.22222 2C5.44952 2 6.44444 2.99492 6.44444 4.22222C6.44444 4.81159 6.21032 5.37682 5.79356 5.79357C5.37682 6.21032 4.81159 6.44444 4.22222 6.44444Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.5b3867b8669adb56c5052ed5b11fefc7.svg";
export { ForwardRef as ReactComponent };